import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'E.g. in review, changes requested or approved',
    name: 'Pull Request Review State',
    partialId: PartialId.Standard.create('pull_request_review_state'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
